import { useState, useEffect, useRef } from 'react';
import {
  HeroSection,
  RealExampleSection,
  ComparisonSection,
  HowItWorksSection,
  PointsSection,
  PricingSection,
  WaitlistSection,
  Footer,
} from '.';
import { SiteHeader } from '../layout';

interface LandingPageProps {
  onGetStarted: () => void;
}

/**
 * Marketing landing page shown to unauthenticated visitors. Composed of
 * independent section components imported from ./landing/.
 */
export function LandingPage({ onGetStarted }: LandingPageProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const heroRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const raf = requestAnimationFrame(() => setIsVisible(true));

    const handleScroll = () => {
      // Nav: binary state avoids re-renders on every scroll pixel
      setIsScrolled(window.scrollY > 50);

      // Hero tilt: direct DOM mutation bypasses React render cycle
      if (heroRef.current) {
        const tiltX = Math.min(window.scrollY * 0.003, 1.5);
        heroRef.current.style.transform = `rotateX(${tiltX}deg)`;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="min-h-screen bg-stone-50 dark:bg-stone-950 overflow-x-hidden">

      <SiteHeader mode="landing" isScrolled={isScrolled} onGetStarted={onGetStarted} />

      <HeroSection
        heroContentRef={heroRef}
        isVisible={isVisible}
      />

      <RealExampleSection />
      <ComparisonSection />
      <HowItWorksSection />
      <PointsSection />
      <PricingSection />
      <WaitlistSection />
      <Footer />
    </div>
  );
}
